import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from '@mui/material';
import { Warning } from '@mui/icons-material';

function ConfirmDialog({
    open,
    title = 'Bevestigen',
    message = 'Weet je zeker dat je door wilt gaan?',
    confirmText = 'Bevestigen',
    cancelText = 'Annuleren',
    confirmColor = 'primary',
    onConfirm,
    onCancel,
    icon = null,
}) {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '8px',
                    p: 1,
                },
            }}
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    fontWeight: 600,
                }}
            >
                {icon || (confirmColor === 'error' && <Warning color="error" />)}
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onCancel} variant="outlined" sx={{ borderRadius: '8px' }}>
                    {cancelText}
                </Button>
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    color={confirmColor}
                    autoFocus
                    sx={{ borderRadius: '8px' }}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmDialog;
